import { StyleSheet } from 'react-native'
import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'wrap',
        // alignItems: 'center'
        minHeight: 80,
    },
    option: theme => ({
        flex: 1,
        minHeight: 65,
        minWidth: 100,
        margin: 4,
        padding: 8,
        borderRadius: 6,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: theme.colors.borderColorTwo,
        backgroundColor: theme.colors.cardBackgroundColor,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    }),
    activeoption: {
        borderWidth: 2,
        borderColor: Colors.ocean,
    },
    title: {
        //  textAlign: 'center'
    },
    activeTitle: {
        ...Fonts.type.bold,
    },
    //Icon Select
    iconOption: {
        alignItems: 'stretch',
    },
    iconSelectWrapper: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    icon: {
        marginRight: 16,
    },
})

export default styles
